import { PureComponent } from 'react'
import _ from 'lodash'
import cx from 'classnames'

import YTable from '../../../Common/YTable'
import { numeralFormat } from '../../../../../lib/renderUtil'
import { SALE_STAT_KEY_MAP } from '../../../../constants/globalTypes'

import styles from './PeriodComparison.css'

const PERIOD_COLUMN_MAP = {
  current: {
    header: '查詢區間',
    accessorKey: 'current'
  },
  previous: {
    header: '上月同期',
    accessorKey: 'previous'
  },
  lastYear: {
    header: '去年同期',
    accessorKey: 'lastYear'
  }
}

const Helper = {
  getColumnByPeriod: (period) => {
    let column = _.get(PERIOD_COLUMN_MAP, period.type, {})
    column = { ...column }
    column.header = `${column.header} (${period.formatedPeriod})`
    return column
  }
}

/** 訂購區間比較  */
class PeriodComparison extends PureComponent {
  /**
   * Generate column of table
   */
  generateTableColumns = () => {
    const { saleStatData } = this.props

    // map object
    const periodColumns = _.map(saleStatData, (periodStat, key) => {
      if (periodStat) {
        return Helper.getColumnByPeriod(periodStat)
      }
    })

    const columns = [{
      id: 'type',
      Header: '數據類型',
      accessor: d => _.get(SALE_STAT_KEY_MAP, `${d.type}.text`, '--'),
      width: 170,
      maxWidth: 170
    }]

    const restColumns = _.map(periodColumns, (periodColumn) => {
      const { header, accessorKey } = periodColumn
      return {
        id: accessorKey,
        Header: header,
        accessor: d => {
          const value = _.get(d, `periods.${accessorKey}`, 0)
          const formatedVal = numeralFormat(value)
          return (
            <span>{formatedVal}</span>
          )
        }
      }
    })
    return [...columns, ...restColumns]
  }

  generateTableData = () => {
    const { saleStatData } = this.props

    const statsResult = {}
    _.map(saleStatData, (periodStat) => {
      const { type, data } = periodStat
      _.map(data, (stat) => {
        // 以key來平整每月資料
        const { key, value } = stat
        const rowObject = statsResult[key]
        statsResult[key] = _.merge(rowObject, { [type]: value })
      })
    })

    const pollutedStats = _.map(statsResult, (periods, type) => {
      if (type === 'newOrderAmount' || type === 'newOrderCount') {
        return {
          type,
          periods
        }
      }
      return null
    })
    // remove null from array
    return _.compact(pollutedStats)
  }

  render () {
    const { className } = this.props
    const clz = cx(styles.periodComparison, {
      [className]: !!className
    })

    const data = this.generateTableData()

    return (
      <div
        data-role='saleStat-periodComparison'
        className={clz}
      >
        <div className={styles.comparisonTableTitle}>
          訂購區間比較
        </div>
        <YTable
          sortable={false}
          resizable={false}
          showPagination={false}
          data={data}
          columns={this.generateTableColumns()}
        />
      </div>
    )
  }
}

export default PeriodComparison
